<template>
  <div>
    <q-dialog v-model="showCrudSearch" @hide="hideModal">
      <q-layout view="Lhh lpR fff" container class="bg-white modal-height">
        <q-card class="modal-height">
          <q-card-section class="row items-center">
            <div class="text-h6">{{ $gettext('ADD_INTEGRATION') }}</div>
            <q-space />
            <q-btn icon="close" size="18px" flat round dense v-close-popup @click=hideModal />
          </q-card-section>
          <q-card-section>
            <crud-form v-if="form" ref="crudForm" :form="form" :model="form.dadosForm" @action-click="actionClick">
              <crud-input class="col-6 q-px-sm q-mt-md" nmInput="typeIntegration" />
            </crud-form>
          </q-card-section>
          <div class="buttons">
            <q-btn color="grey-7" @click="clearForm">
              {{ $gettext('CLEAN') }}
            </q-btn>
            <q-btn color="primary" @click="save">
              {{ $gettext('SAVE') }}
            </q-btn>
          </div>
        </q-card>
      </q-layout>
    </q-dialog>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import { repository } from 'jtech'

const { form, input } = JtCrud

@Component({
  name: 'TypeIntegration',
  components: {
    'crud-form': form, 'crud-input': input
  },
  props: {

  }
})
class TypeIntegration extends Vue {
  showCrudSearch = false

  form = null
  clientGeneratorResidueData = null

  hideModal () {
    this.clearForm()
    this.clientGeneratorResidueData = null
    this.showCrudSearch = false
  }

  clearForm () {
    this.form.dadosForm.typeIntegration = ''
  }

  async save () {
    await repository.resolveLogic('clientGeneratorResidue.saveIntegration',
      {
        typeIntegration: this.form.dadosForm.typeIntegration,
        generatorResidueId: this.clientGeneratorResidueData.id
      })
    this.hideModal()
    this.$emit('on-save')
  }

  get typeIntegration () {
    return this.form?.dadosForm?.typeIntegration
  }

  async openSerachModal (clientGeneratorResidueData) {
    const { id, client } = clientGeneratorResidueData
    this.clientGeneratorResidueData = clientGeneratorResidueData
    const allInterfaceInfos = await repository.resolve('clientGeneratorResidue.getTypesIntegration', { clientGeneratorResidue: id, client })
    const typeIntegrationSgzValue = allInterfaceInfos[0]?.relacionamentos?.typeIntegration[0]?.value
    this.createForm(allInterfaceInfos)
    this.hasAlreadyAnIntegration(clientGeneratorResidueData?.typeIntegration, typeIntegrationSgzValue)
    this.showCrudSearch = true
  }

  hasAlreadyAnIntegration (typeIntegrationSavedOnGrid, typeIntegrationSgzValue) {
    if (typeIntegrationSavedOnGrid != null && typeIntegrationSgzValue != null) {
      this.form.dadosForm.typeIntegration = typeIntegrationSavedOnGrid
    }
  }

  createForm (allInterfaceInfos) {
    this.form = {
      inputs: allInterfaceInfos[0].inputs,
      dadosForm: { typeIntegration: null },
      nmInterface: allInterfaceInfos[0].nmInterface,
      relacionamentos: allInterfaceInfos[0].relacionamentos
    }
  }
}
export default TypeIntegration
</script>
<style scoped>
.buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
  position: relative;
  top: 35px
}

.modal-height {
  height: 300px;
}
</style>
